import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { portalInterimNamespace } from '../namespaces';
/**
 * Flag for devs to temporarily enable some dev features
 */
export const devMode = createStorageValue({
    namespace: portalInterimNamespace,
    schema: z.boolean(),
    type: 'local',
    id: Symbol('devMode'),
});
